import { navLinks } from "@/mocks/maydayContent";

export default function Footer() {
  const year = 2026;
  return (
    <footer className="w-full bg-background-200/80 border-t border-background-300/60">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-12">
        <div className="grid gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#home" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-sparkling-2-fill text-lg w-5 h-5 flex items-center justify-center"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-bold text-foreground-950">五一爆料</span>
                <span className="mt-0.5 text-[10px] tracking-[0.2em] text-foreground-500">节日背后的真相</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              专注劳动节假期安排、调休争议、节日消费与出游乱象的独立观察与实用指南。
            </p>
          </div>

          <div className="md:col-span-4">
            <div className="text-sm font-semibold text-foreground-900">栏目导航</div>
            <nav className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {navLinks.slice(0, 8).map((l) => (
                <a key={l.id} href={`#${l.id}`} className="flex items-center gap-1.5 text-sm text-foreground-600 hover:text-primary-700 transition-colors">
                  <i className="ri-arrow-right-s-line text-primary-400 w-3.5 h-3.5 flex items-center justify-center"></i>
                  {l.label}
                </a>
              ))}
            </nav>
          </div>

          <div className="md:col-span-3">
            <div className="text-sm font-semibold text-foreground-900">联系我们</div>
            <ul className="mt-3 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                tips@maydayleaks.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                工作日 09:00 - 18:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-chat-3-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                线索核实后 5 个工作日内反馈
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-center text-xs text-foreground-500 sm:text-left">
            © {year} 五一爆料 · 本站信息仅供参考，具体假期与政策以官方发布为准。
          </p>
          <a
            href="#home"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-3.5 py-2 text-xs font-medium text-background-50 hover:bg-foreground-800 transition-colors"
          >
            返回顶部
            <i className="ri-arrow-up-line text-xs w-3 h-3 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}